<template>
  <div
    :style="tamanho ? `width: ${tamanho}px; height: ${tamanho}px;` : ''"
    :class="['animation-container', `${classe}-square`]"
    :key="`key-loading-${grow}`"
  >
    <div class="third-square square"></div>
    <div class="second-square square"></div>
    <div class="first-square square"></div>
  </div>
</template>

<script>
export default {
  name: "Quadrado",
  props: {
    tamanho: String,
    classe: String
  },
  data() {
    return {
      grow: true
    };
  },
  mounted() {
    this.trocaAnimacao();
  },
  methods: {
    trocaAnimacao() {
      setTimeout(() => {
        this.grow = !this.grow;
        this.trocaAnimacao();
      }, 3000);
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes loadingAnimationSquare1 {
  0% {
    transform: translate(0, 0) rotate(45deg);
  }
  7% {
    transform: translate(-71%, -71%) rotate(45deg);
  }
  25% {
    transform: translate(-71%, -71%) rotate(45deg);
  }
  32% {
    transform: translate(0, -142%) rotate(45deg);
  }
  50% {
    transform: translate(0, -142%) rotate(45deg);
  }
  57% {
    transform: translate(71%, -71%) rotate(45deg);
  }
  75% {
    transform: translate(71%, -71%) rotate(45deg);
  }
  82% {
    transform: translate(0, 0) rotate(45deg);
  }
  100% {
    transform: translate(0, 0) rotate(45deg);
  }
}
@keyframes loadingAnimationSquare2 {
  0% {
    transform: translate(71%, -71%) rotate(45deg);
  }
  9% {
    transform: translate(71%, -71%) rotate(45deg);
  }
  16% {
    transform: translate(0, 0) rotate(45deg);
  }
  34% {
    transform: translate(0, 0) rotate(45deg);
  }
  41% {
    transform: translate(-71%, -71%) rotate(45deg);
  }
  59% {
    transform: translate(-71%, -71%) rotate(45deg);
  }
  66% {
    transform: translate(0, -142%) rotate(45deg);
  }
  84% {
    transform: translate(0, -142%) rotate(45deg);
  }
  91% {
    transform: translate(71%, -71%) rotate(45deg);
  }
  100% {
    transform: translate(71%, -71%) rotate(45deg);
  }
}
@keyframes loadingAnimationSquare3 {
  0% {
    transform: translate(0, -142%) rotate(45deg);
  }
  18% {
    transform: translate(0, -142%) rotate(45deg);
  }
  25% {
    transform: translate(71%, -71%) rotate(45deg);
  }
  43% {
    transform: translate(71%, -71%) rotate(45deg);
  }
  50% {
    transform: translate(0, 0) rotate(45deg);
  }
  68% {
    transform: translate(0, 0) rotate(45deg);
  }
  75% {
    transform: translate(-71%, -71%) rotate(45deg);
  }
  93% {
    transform: translate(-71%, -71%) rotate(45deg);
  }
  100% {
    transform: translate(0, -142%) rotate(45deg);
  }
}
.animation-container {
  position: relative;
  width: 31px;
  height: 31px;
  scale: 1;
  // background: red;
  display: flex;
  align-items: center;
  justify-content: center;
}
.square {
  border: 1px solid #58585873;
  border-radius: 15%;
  position: absolute;
  height: 35%;
  width: 35%;
  bottom: 7%;
  transform-origin: center;
}
.first-square {
  background: var(--cinza02);
  filter: brightness(1.1);
  animation: loadingAnimationSquare1 3s infinite linear;
}
.second-square {
  background: var(--cinza02);
  filter: brightness(0.7);
  animation: loadingAnimationSquare2 3s infinite linear;
}
.third-square {
  background: var(--cinza02);
  animation: loadingAnimationSquare3 3s infinite linear;
}
.preferencia_tarifaria-square,
.class_importacao-square {
  .first-square {
    background: var(--importacao);
    filter: brightness(1.3);
  }
  .second-square {
    background: var(--importacao);
    filter: brightness(0.8);
  }
  .third-square {
    background: var(--importacao);
  }
}

.pis_cofins-square,
.cide_combustivel-square {
  .first-square {
    background: var(--pis-cofins);
    filter: brightness(1.3);
  }
  .second-square {
    background: var(--pis-cofins);
    filter: brightness(0.8);
  }
  .third-square {
    background: var(--pis-cofins);
  }
}

.icms_interno-square,
.icms_st-square,
.carga_liquida-square,
.antecipacao-square,
.difal-square {
  .first-square {
    background: var(--icms);
    filter: brightness(1.3);
  }
  .second-square {
    background: var(--icms);
    filter: brightness(0.8);
  }
  .third-square {
    background: var(--icms);
  }
}

.ipi-square {
  .first-square {
    background: var(--ipi);
    filter: brightness(1.3);
  }
  .second-square {
    background: var(--ipi);
    filter: brightness(0.8);
  }
  .third-square {
    background: var(--ipi);
  }
}
.azul-square {
  .first-square {
    background: var(--azul2);
    filter: brightness(1.3);
  }
  .second-square {
    background: var(--azul2);
    filter: brightness(0.85);
  }
  .third-square {
    background: var(--azul2);
  }
}
.verde-square {
  .first-square {
    background: var(--verde2);
    filter: brightness(1.3);
  }
  .second-square {
    background: var(--verde2);
    filter: brightness(0.85);
  }
  .third-square {
    background: var(--verde2);
  }
}
.vermelho-square {
  .first-square {
    background: var(--vermelho2);
    filter: brightness(1.3);
  }
  .second-square {
    background: var(--vermelho2);
    filter: brightness(0.9);
  }
  .third-square {
    background: var(--vermelho2);
  }
}
.laranja-square {
  .first-square {
    background: var(--laranja2);
    filter: brightness(1.3);
  }
  .second-square {
    background: var(--laranja2);
    filter: brightness(0.85);
  }
  .third-square {
    background: var(--laranja2);
  }
}
</style>
